import { Injectable } from '@angular/core';
import {  Subject } from 'rxjs';
import { HealthSystemSetup } from 'src/app/core/model/v2/practice/HealthSystemSetup';
import { UserSetup } from '../../core/model/v2/practitioner/UserSetup';

@Injectable({
  providedIn: 'root'
})
export class SetupService {

  physicianIsOpened = false;
  assistantIsOpened = false;
  careGiverIsOpened = false;
  staffIsOpened = false;
  practiceIsOpened = false;
  APPIsOpened = false;
  attorneyIsOpened=false;
  caseManagerIsOpened=false;
  editStaff$ = new Subject<UserSetup>();
  editPractice$ = new Subject<HealthSystemSetup>();

  editPhysician$ = new Subject<UserSetup>();
  editCareGiver$ = new Subject<UserSetup>();
  editPhysicianAssistant$ = new Subject<UserSetup>();
  editAPP$ = new Subject<UserSetup>();
  editAttorney$=new Subject<UserSetup>();
  editCaseManager$=new Subject<UserSetup>();

  isSetupCompleted$ = new Subject();

  constructor() { }
}

